/**
 * Runs `scroll` with animation suppressed, whatever `scroll-behavior` the
 * stylesheet sets on the root element.
 *
 * EGDE-719 (r2): `behavior: "instant"` says this in one word, but it is a
 * WebIDL enum value and Safari before 15.4 throws `TypeError` on it rather than
 * ignoring it. Both call sites sit inside click handlers that have already
 * called `preventDefault()`, so a throw does not degrade to the old behaviour —
 * it strands the interaction (the header logo would simply stop working).
 *
 * Neutralising the CSS for the duration is what Next does internally for the
 * same reason, `getClientRects()` included: the inline style has to be in
 * effect before the scroll is issued, and only a forced layout guarantees that
 * within one task.
 */
export function scrollInstantly(scroll: () => void) {
  const html = document.documentElement
  const previous = html.style.scrollBehavior
  html.style.scrollBehavior = "auto"
  html.getClientRects()
  try {
    scroll()
  } finally {
    html.style.scrollBehavior = previous
  }
}
